import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import HeadlessInput from '../../../shared/component/headless/input/HeadlessInput';
import { MemberInfoValueMobile } from '../../../shared/component/headless/input/InputBody';
import HeadlessBtn from '../../../shared/component/headless/button/HeadlessBtn';
import { BlackFullWidthBtn } from '../../../shared/component/headless/button/BtnBody';
import { useModalStore } from '../../../shared/store/portal/modalStore';
import { useValidation } from '../../../shared/hooks/useValidation';
import { useAuth } from '../../../shared/hooks/useApi/useAuth';
import Space from '../../../shared/Space';
import { AlertPosition, AlertType } from '../../../shared/enum/EnumRepository';
import { useStandardAlertStore } from '../../../shared/store/portal/alertStore';
import { getAlertMessage } from '../../../shared/constants/alertMessages';
import { getModalMessage } from '../../../shared/constants/modalMessages';
import { getBtnName } from '../../../shared/constants/btnNames';
import UniversalIconBtn from '../../../shared/component/headless/button/UniversalIconBtn';
import { MobileHeader, Title } from '../../../shared/component/modal/SearchModalLayout';
import belowIcon from '../../../asset/icon/below.png';

interface ModalProps {
  setIsUserInput: (isUserInput: boolean) => void;
}

const FindPWModalMobile: React.FC<ModalProps> = ({ setIsUserInput }) => {
  const { findPassword } = useAuth();
  const { standardModal, clearModal } = useModalStore();
  const { enqueueAlert } = useStandardAlertStore();
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const { isEmail } = useValidation();

  useEffect(() => {
    if (email.length > 0) {
      setIsUserInput(true);
    } else {
      setIsUserInput(false);
    }
  }, [email, setIsUserInput]);

  if (standardModal == null) return null;

  const validateEmail = (value: string) => {
    if (value.length === 0) {
      setEmailError('');
      return true;
    }
    if (!isEmail(value)) {
      setEmailError('Invalid email format');
      return false;
    }
    setEmailError('');
    return true;
  };

  const changeEmailInput = (value: string) => {
    validateEmail(value);
    setEmail(value);
  }

  const handleChange = async () => {
    if (email === '') {
      enqueueAlert({
        type: AlertType.ALERT,
        position: AlertPosition.TOP,
        content: getAlertMessage('MISSING_REQUIRED_FIELD')
      })
      return;
    }
    if (emailError) {
      enqueueAlert({
        type: AlertType.ALERT,
        position: AlertPosition.TOP,
        content: getAlertMessage('CHECK_FORMAT')
      })
      return;
    }

    await findPassword({ email });
  };

  return (
    <ChangeModalComp>
      <MobileHeader>
        <Title>{getModalMessage('FIND_PASSWORD_TITLE')}</Title>
        <UniversalIconBtn
          size="fit"
          border={false}
          isTransparent
          backgroundImg={belowIcon}
          onClick={() => clearModal(400)}
          aria-label="Close"
        />
      </MobileHeader>
      <HeadlessInput
        type={'text'}
        value={email}
        handleChange={(e) => changeEmailInput(e.target.value)}
        placeholder={getModalMessage('ENTER_EMAIL')}
        StyledInput={MemberInfoValueMobile}
      />
      <Space $height="20px">
        {emailError && <ErrorText>{emailError}</ErrorText>}
      </Space>
      <HeadlessBtn
        value={getBtnName('FIND')}
        handleClick={handleChange}
        StyledBtn={SubmitButton}
      />
    </ChangeModalComp>
  );
};

const ChangeModalComp = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 14px;
`

const SubmitButton = styled(BlackFullWidthBtn)`
  margin: 20px 0px 15px 0px;
`;

const ErrorText = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.color_alert_red};
  ${({ theme }) => theme.typography.Body_04};
`;

export default FindPWModalMobile;
